module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/label-edit/label-edit.component.css
// module id = ./src/app/admin/label-edit/label-edit.component.css
// module chunks = main